import { nullable, number, object, string } from "superstruct";

const PurchasedProductSchema = object({
    productId: number(),
    title: string(),
    imageUrl: nullable(string()),
    handle: string(),
});

export default PurchasedProductSchema;
